<template>
  <div class="center-warp">
    <div class="inner d-flex-between">
      <div class="left-menu">
        <div :class="menuIndex == 0 ? 'on':''" @click="menuChange(0)">基本资料</div>
        <div v-if="createType != '功能矫治器' && createType != '隐形矫治器加工'" :class="menuIndex == 1 ? 'on':''"
             @click="menuChange(1)">图片资料
        </div>
        <div v-if="showMoreData" :class="menuIndex == 2 ? 'on':''" @click="menuChange(2)">补充资料</div>
      </div>
      <div ref="contRef" class="right-cont" @scroll="handScroll">
        <div ref="part1" class="add-item">
          <div class="add-data-title">基本资料</div>
          <template v-if="createType == '首诊卡'">
            <div class="d-flex-between">
              <div class="add-data-item">
                <div>姓名</div>
                <div class="add-data-item-input"><input v-model="cardShouzhenOption.name" placeholder="填写姓名"
                                                        type="text"></div>
              </div>
              <div class="add-data-item">
                <div>出生日期</div>
                <el-date-picker
                    v-model="cardShouzhenOption.birthday"
                    :picker-options="pickerBornOption"
                    class="add-data-item-input"
                    clear-icon="none"
                    placeholder="选择出生日期"
                    prefix-icon="el-icon-arrow-right"
                    type="date"
                    @change="bornDateChange">
                </el-date-picker>
              </div>
              <div class="add-data-item">
                <div>期望套餐类型</div>
                <el-dropdown trigger="click" @command="handelPackageChange">
                  <div class="add-data-item-input"><input :value="packageType.name" placeholder="选择套餐类型"
                                                          type="text"><i
                      class="iconfont icon-youjiantou"></i></div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in packageList"
                                      :command="item" :disabled="createItem.confirm_first_case_type != null ? true : false ">{{ item.name }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="add-data-item">
                <div>首诊日期</div>
                <el-date-picker
                    v-model="cardShouzhenOption.card_date"
                    :picker-options="pickerBornOption"
                    class="add-data-item-input"
                    clear-icon="none"
                    placeholder="选择首诊日期"
                    prefix-icon="el-icon-arrow-right"
                    type="date"
                    @change="firstDateChange">
                </el-date-picker>
              </div>
            </div>
            <div class="add-data-item">
              <div>病例主诉</div>
              <textarea v-model="cardShouzhenOption.case_info" class="case-main-info"
                        placeholder="填写病例主要诉求…"></textarea>
            </div>
          </template>
          <template v-if="createType == '复诊卡'">
            <div class="d-flex-between">
              <div class="add-card-data"><span>姓名：</span><span class="black-14">{{ createItem.name }}</span></div>
              <div class="add-card-data"><span>病例年龄：</span><span class="black-14">{{ createItem.age_text }}</span>
              </div>
              <div class="add-card-data"><span>{{createItem.confirm_first_case_type_text ? '确认' : '期望'}}套餐类型：</span><span class="black-14">{{
                  createItem.confirm_first_case_type_text ? createItem.confirm_first_case_type_text : createItem.first_case_type_name
                }}</span></div>
            </div>
            <div class="d-flex-between">
              <div class="add-data-item">
                <div>复诊日期<span class="require">*</span></div>
                <el-date-picker
                    v-model="cardFuzhenOption.card_date"
                    :picker-options="pickerBornOption"
                    class="add-data-item-input"
                    clear-icon="none"
                    placeholder="选择复诊日期"
                    prefix-icon="el-icon-arrow-right"
                    type="date"
                    @change="dateChange($event,1)">
                </el-date-picker>
              </div>
            </div>
            <div class="add-data-item">
              <div>复诊情况<span class="require">*</span></div>
              <textarea v-model="cardFuzhenOption.being_treatment" class="case-main-info"
                        placeholder="填写本次复诊情况…"></textarea>
            </div>
          </template>
          <template v-if="createType == '会诊卡'">
            <div class="d-flex-between">
              <div class="add-card-data"><span>姓名：</span><span class="black-14">{{ createItem.name }}</span></div>
              <div class="add-card-data"><span>病例年龄：</span><span class="black-14">{{ createItem.age_text }}</span>
              </div>
              <div class="add-card-data"><span>{{createItem.confirm_first_case_type_text ? '确认' : '期望'}}套餐类型：</span><span class="black-14">{{
                  createItem.confirm_first_case_type_text ? createItem.confirm_first_case_type_text : createItem.first_case_type_name
                }}</span></div>
            </div>
            <div class="add-card-data"><span>首诊主诉：</span><span class="black-14">{{ createItem.case_info }}</span>
            </div>
            <div class="d-flex-between">
              <div class="add-data-item">
                <div>会诊卡时间<span class="require">*</span></div>
                <el-date-picker
                    v-model="cardHuizhenOption.card_date"
                    :picker-options="pickerBornOption"
                    class="add-data-item-input"
                    clear-icon="none"
                    placeholder="选择会诊日期"
                    prefix-icon="el-icon-arrow-right"
                    type="date"
                    @change="dateChange($event,2)">
                </el-date-picker>
              </div>
            </div>
            <div class="add-data-item">
              <div>会诊情况<span class="require">*</span></div>
              <textarea v-model="cardHuizhenOption.being_treatment" class="case-main-info"
                        placeholder="填写本次复诊情况…"></textarea>
            </div>
          </template>
          <template v-if="createType == '图像卡'">
            <div class="add-data-item">
              <div>正在进行的诊疗<span class="require">*</span></div>
              <textarea v-model="cardTuxiangOption.being_treatment" class="case-main-info"
                        placeholder="请输入正在进行的诊疗情况…"></textarea>
            </div>
          </template>
        </div>
        <div ref="part2" class="add-item">
          <div class="add-data-title">图片资料 <span>请上传图片资料</span></div>
          <div v-if="createType !== '图像卡'" class="upload-img-warp">
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem3-l">
                <template v-if="addCardImgOption.cemian_pic == '' || addCardImgOption.cemian_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'cemian_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >侧面照</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.cemian_pic" alt="" class="upload-img-item-val"
                       @click="editCaseImg('cemian_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('cemian_pic')">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-l">
                <template v-if="addCardImgOption.zhengmian_pic == '' || addCardImgOption.zhengmian_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengmian_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正面照</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.zhengmian_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('zhengmian_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('zhengmian_pic')">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-l">
                <template
                    v-if="addCardImgOption.zhengmian_weixiao_pic == '' || addCardImgOption.zhengmian_weixiao_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengmian_weixiao_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正面微笑照</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.zhengmian_weixiao_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('zhengmian_weixiao_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('zhengmian_weixiao_pic')">
                </template>
              </div>
            </div>
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem3-s">
                <template v-if="addCardImgOption.youce_yaohe_pic == '' || addCardImgOption.youce_yaohe_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'youce_yaohe_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >右侧位咬合照</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.youce_yaohe_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('youce_yaohe_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('youce_yaohe_pic')">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-s">
                <template
                    v-if="addCardImgOption.zhengwei_yaohe_pic == '' || addCardImgOption.zhengwei_yaohe_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengwei_yaohe_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正位咬合照</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.zhengwei_yaohe_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('zhengwei_yaohe_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('zhengwei_yaohe_pic')">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-s">
                <template v-if="addCardImgOption.zuoce_yaohe_pic == '' || addCardImgOption.zuoce_yaohe_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zuoce_yaohe_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >左侧咬合照</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.zuoce_yaohe_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('zuoce_yaohe_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('zuoce_yaohe_pic')">
                </template>
              </div>
            </div>
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem1">
                <template v-if="addCardImgOption.quanjing_pic == '' || addCardImgOption.quanjing_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'quanjing_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg3.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >全景照</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.quanjing_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('quanjing_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('quanjing_pic')">
                </template>
              </div>
            </div>
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem2">
                <template v-if="addCardImgOption.ceweimian_x_pic == '' || addCardImgOption.ceweimian_x_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'ceweimian_x_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg4.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >侧位片(X光)</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.ceweimian_x_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('ceweimian_x_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('ceweimian_x_pic')">
                </template>
              </div>
              <div>
                <div class="upload-img-line">
                  <div class="upload-img-item uploadItem3-s">
                    <template
                        v-if="addCardImgOption.shanglingyalie_pic == '' || addCardImgOption.shanglingyalie_pic == null">
                      <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                                 :action="'shanglingyalie_pic'">
                        <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                        <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                      </el-upload>
                      <div class="upload-img-item-name" >上颌牙列照</div>
                    </template>
                    <template v-else>
                      <img :src="addCardImgOption.shanglingyalie_pic" alt=""
                           class="upload-img-item-val" @click="editCaseImg('shanglingyalie_pic')">
                      <img alt="" class="upload-img-item-del"
                           src="@/assets/img/case_management/del2.png" @click="delCaseImg('shanglingyalie_pic')">
                    </template>
                  </div>
                </div>
                <div class="upload-img-line">
                  <div class="upload-img-item uploadItem3-s">
                    <template
                        v-if="addCardImgOption.xialingyalie_pic == '' || addCardImgOption.xialingyalie_pic == null">
                      <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                                 :action="'xialingyalie_pic'">
                        <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                        <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                      </el-upload>
                      <div class="upload-img-item-name" >下颌牙列照</div>
                    </template>
                    <template v-else>
                      <img :src="addCardImgOption.xialingyalie_pic" alt=""
                           class="upload-img-item-val" @click="editCaseImg('xialingyalie_pic')">
                      <img alt="" class="upload-img-item-del"
                           src="@/assets/img/case_management/del2.png" @click="delCaseImg('xialingyalie_pic')">
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem3-m">
                <template v-if="addCardImgOption.fuhe_fugai_pic == '' || addCardImgOption.fuhe_fugai_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'fuhe_fugai_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >覆合覆盖照 <span>（选填）</span></div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.fuhe_fugai_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('fuhe_fugai_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('fuhe_fugai_pic')">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-m">
                <template
                    v-if="addCardImgOption.zhengmian_kaikou_zhao == '' || addCardImgOption.zhengmian_kaikou_zhao == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengmian_kaikou_zhao'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正面开口照 <span>（选填）</span></div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.zhengmian_kaikou_zhao" alt=""
                       class="upload-img-item-val" @click="editCaseImg('zhengmian_kaikou_zhao')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('zhengmian_kaikou_zhao')">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-m">
                <template
                    v-if="addCardImgOption.zhengmian_yangshi_pic == '' || addCardImgOption.zhengmian_yangshi_pic == null">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengmian_yangshi_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正面仰视照 <span>（选填）</span></div>
                  <div class="upload-img-item-tips">注: 反合病例替换为正面切对切咬合照</div>
                </template>
                <template v-else>
                  <img :src="addCardImgOption.zhengmian_yangshi_pic" alt=""
                       class="upload-img-item-val" @click="editCaseImg('zhengmian_yangshi_pic')">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCaseImg('zhengmian_yangshi_pic')">
                </template>
              </div>
            </div>
          </div>
          <div v-if="createType == '图像卡'" class="upload-img-warp">
            <template v-for="(item,index) in cardTuxiangOption.image_card_list">
              <div class="d-flex-between" style="align-items: center">
                <div class="add-card-data"><span>图片{{ index + 1 }}</span></div>
                <div v-if="index != 0" class="iconfont icon-pizhu-qingkonghuaban del-img-btn"
                     @click="delImgGroup(index)"></div>
              </div>
              <div class="d-flex-warp upload-tuxiang-line">
                <div v-for="(subItem,subIndex) in item.img" class="upload-img-item uploadItem3-s">
                  <img :src="subItem" alt="" class="upload-img-item-val" @click="editCardImg(index,subIndex)">
                  <img alt="" class="upload-img-item-del"
                       src="@/assets/img/case_management/del2.png" @click="delCardImg(index,subIndex)">
                </div>
                <div class="upload-img-item uploadItem3-s">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgCardPre" :multiple="true"
                             :action="''" :data="{i:index}">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                </div>
              </div>
              <textarea v-model="item.text" class="case-main-info" placeholder="请输入图片描述内容"></textarea>
            </template>
            <div class="add-tupian-btn black-14" @click="addImgGroup"><i class="iconfont icon-xinzeng"></i>再加一组图片
            </div>
          </div>
        </div>
        <div v-if="showMoreData" ref="part3" class="add-item">
          <div class="add-data-title">补充视频资料</div>
          <div class="case-upload-line">
            <div v-for="i in 2" class="upload-video-item">
              <video controls src="../../assets/img/case_management/test.mp4"></video>
              <div>MP4</div>
              <img alt="" class="upload-img-item-del" src="../../assets/img/case_management/del2.png">
            </div>
            <div class="upload-video">
              <img alt="" class="upload-video-bg" src="../../assets/img/case_management/upload-video-bg.png">
              <img alt="" class="upload-video-icon" src="../../assets/img/case_management/upload-video-icon.png">
              <div class="black-14">上传视频</div>
            </div>
          </div>
        </div>
        <div class="annotate-btn">
          <div @click="goBack">取消</div>
          <div @click="saveAddCase">保存</div>
        </div>
      </div>
      <el-dialog
          :close-on-click-modal="false"
          :visible.sync="showImgEditor"
          custom-class="take-dialog"
          title="图片编辑"
          width="1080px">
        <div class="img-editor-warp">
          <div style="width: 1040px;height: 760px;">
            <EditImg ref="editImg" :key="createType == '图像卡' ? editImgUrl : addCardImgOption[editImgName]" :bgUrl="createType == '图像卡' ? editImgUrl : addCardImgOption[editImgName]" />
          </div>
          <div class="d-flex" style="justify-content: flex-end">
            <div class="img-editor-right-btn">
              <div @click="showImgEditor = false">取消</div>
              <div @click="editImgOK">确定</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import EditImg from '@/components/EditImg'
import {GetCaseCardInfo, GetCaseInfo, GetListByTypeCode, UpdateCaseCard} from "@/http/api";
import ossUpload from "@/http/ossUpload";

export default {
  name: "add_case",
  components: {EditImg},
  data() {
    return {
      menuIndex: 0,
      menuOffsetTop: [],
      packageType: {},
      showImgEditor: false,
      createType: '',
      createItem: {},
      cutImgUrl: require('../../assets/img/case_management/test-upload-img.png'),
      cardShouzhenOption: {
        birthday: '', //出生日期
        card_date: '', //卡日期
        case_info: '',//首诊主诉
        first_case_type: '',//期望套餐类型，4：快乐+,5：散件,6：全周期（含耗材）7：双期第一期（含耗材）8：双期第二期（含耗材）注意：如果不传这个值，默认就为散件
        name: '',//患者姓名
      },
      cardFuzhenOption: {
        being_treatment: '',
        card_date: ''
      },
      cardHuizhenOption: {
        being_treatment: '',
        card_date: ''
      },
      cardTuxiangOption: {
        being_treatment: '',
        image_card_list: []
      },
      design_card_id: {},
      model_file_url: [],
      addCardImgOption: {
        cemian_pic: '',//侧面照
        ceweimian_x_pic: '',//侧位面x照
        fuhe_fugai_pic: '',//覆合覆盖照
        other_media_json: [],//其他图文或者视频资料
        quanjing_pic: '',//全景片
        shanglingyalie_pic: '', //上领牙列照
        xialingyalie_pic: '', //下领牙列照
        youce_yaohe_pic: '', //右侧位咬合照
        zhengmian_kaikou_zhao: '',//正面开口照
        zhengmian_pic: '', //正面照
        zhengmian_weixiao_pic: '', //正面微笑照
        zhengmian_yangshi_pic: '', //正面仰视照
        zhengwei_yaohe_pic: '', //正位咬合照
        zuoce_yaohe_pic: '',  //左侧位咬合照
      },
      editImgName: '',
      editImgId: [],
      editImgUrl: '',
      showMoreData: false,
      member: JSON.parse(localStorage.getItem('member')),
      designCardList: [],
      designModel: [],
      showDesignModelDialog: false,
      designType: {},
      areaData: {},
      receiverArea: [],
      pickerBornOption: {
        disabledDate(time) {
          return time.getTime() > new Date().getTime()
        }
      },
      packageList: [],
    }
  },
  mounted() {

    this.$store.commit('breadChange', {name: '病例管理', isBack: true, url: '/case_management'})
    this.$nextTick(() => {
      this.menuOffsetTop[0] = this.$refs.part1.offsetTop
      this.menuOffsetTop[1] = this.$refs.part2.offsetTop
      if (this.showMoreData) this.menuOffsetTop[2] = this.$refs.part3.offsetTop
      else this.menuOffsetTop[2] = 9999
    })
    //病例卡资料
    GetCaseInfo({id: this.$route.query.id}).then(res => {
      this.createItem = res.data
      if (this.createType == '首诊卡') {
        Object.keys(this.cardShouzhenOption).forEach((key) => {
          this.cardShouzhenOption[key] = res.data[key]
        })
        this.cardShouzhenOption.card_date = new Date(res.data.sz_date)
        //期望套餐类型
        GetListByTypeCode({type_code: ['app_patient_first_case_type']}).then(res2 => {
          this.packageList = res2.data.app_patient_first_case_type
          for (let i = 0; i < res2.data.app_patient_first_case_type.length; i++) {
            if (res2.data.app_patient_first_case_type[i].item_value == res.data.first_case_type) {
              this.packageType = res2.data.app_patient_first_case_type[i]
              this.cardShouzhenOption.first_case_type = res.data.first_case_type
            }
          }
        })
      }
    })
    // 回显数据赋值
    GetCaseCardInfo({id: this.$route.query.card_id}).then(res => {
      this.createType = res.data.type_name
      if (res.data.type_id == 2) {
        Object.keys(this.cardFuzhenOption).forEach((key) => {
          this.cardFuzhenOption[key] = res.data[key]
        })
      } else if (res.data.type_id == 3) {
        Object.keys(this.cardHuizhenOption).forEach((key) => {
          this.cardHuizhenOption[key] = res.data[key]
        })
      } else if (res.data.type_id == 4) {
        Object.keys(this.cardTuxiangOption).forEach((key) => {
          this.cardTuxiangOption[key] = res.data[key]
        })
      }
      if (res.data.type_id != 4) {
        Object.keys(this.addCardImgOption).forEach((key) => {
          this.addCardImgOption[key] = res.data[key]
        })
      }
    })
  },
  methods: {
    handScroll(e) {
      if (e.target.scrollTop < this.menuOffsetTop[1] - 10) {
        this.menuIndex = 0
      } else if (e.target.scrollTop >= this.menuOffsetTop[1] - 20 && e.target.scrollTop < this.menuOffsetTop[2] - 20) {
        this.menuIndex = 1
      } else this.menuIndex = 2

    },
    menuChange(i) {
      this.menuIndex = i
      this.$refs.contRef.scrollTo({
        top: this.menuOffsetTop[i],
        behavior: 'smooth'
      })
    },
    bornDateChange(val) {
      this.cardShouzhenOption.birthday = val
    },
    firstDateChange(val) {
      this.cardShouzhenOption.card_date = val
    },
    dateChange(val, i) {
      if (i == 1) this.cardFuzhenOption.card_date = val
      if (i == 2) this.cardHuizhenOption.card_date = val
    },
    handelPackageChange(val) {
      this.packageType = val
    },
    realTime(data) {
      // console.log(data)
    },
    radioChange(val) {
      this.cardJiaozhiOption.dz_type = val
    },
    editImgOK() {
      let blobUrl = this.$refs.editImg.saveImg()
      this.uploadImg(blobUrl)
      this.showImgEditor = false
    },
    uploadImg(file) {
      ossUpload.bucketUpload(file, (res) => {
        if (this.createType == '图像卡') this.$set(this.cardTuxiangOption.image_card_list[this.editImgId[0]].img, this.editImgId[1], res.url)
        else this.$set(this.addCardImgOption, this.editImgName, res.url)
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/pc/')
    },
    handleFileChange(e) {
      ossUpload.bucketUpload(e.target.files[0], (res) => {
        this.cardJiaozhiOption.model_file_url.push(res.url)
        this.model_file_url.push(res)
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/file/pc/')
    },
    uploadImgPre(e){
      this.handleImgChange(e.file,e.action)
    },
    handleImgChange(file, name) {
      ossUpload.bucketUpload(file, (res) => {
        this.addCardImgOption[name] = res.url
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/pc/')
    },
    uploadImgCardPre(e){
      this.handleCardImgChange(e.file,e.data.i)
    },
    handleCardImgChange(file, i1) {
      ossUpload.bucketUpload(file, (res) => {
        this.cardTuxiangOption.image_card_list[i1].img.push(res.url)
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/pc/create_edit/')
    },
    delCaseImg(name) {
      this.addCardImgOption[name] = ''
    },
    delCardImg(i1, i2) {
      this.cardTuxiangOption.image_card_list[i1].img.splice(i2, 1)
    },
    delImgGroup(i) {
      this.cardTuxiangOption.image_card_list.splice(i, 1)
    },
    delFileGroup(i) {
      this.cardJiaozhiOption.model_file_url.splice(i, 1)
      this.model_file_url.splice(i, 1)
    },
    editCaseImg(name) {
      this.editImgName = name
      this.showImgEditor = true
    },
    editCardImg(i1, i2) {
      this.editImgId = [i1, i2]
      this.editImgUrl = this.cardTuxiangOption.image_card_list[i1].img[i2]
      this.showImgEditor = true
    },
    addImgGroup() {
      this.cardTuxiangOption.image_card_list.push({
        text: '',
        img: []
      })
    },
    goBack() {
      this.$router.push('/case_management')
    },
    saveAddCase() {
      if (!this.$store.state.workState) return false
      let wrongTxt = ''
      let obj = {}
      if (this.createType == '首诊卡') {
        this.cardShouzhenOption.first_case_type = this.packageType.item_value
        this.cardShouzhenOption.birthday = new Date(this.cardShouzhenOption.birthday).toLocaleDateString().replaceAll('/', '.')
        this.cardShouzhenOption.card_date = new Date(this.cardShouzhenOption.card_date).toLocaleDateString().replaceAll('/', '.')
        if (this.cardShouzhenOption.name.trim() == '') wrongTxt = '姓名不能为空'
        else if (this.cardShouzhenOption.birthday == '') wrongTxt = '出生日期不能为空'
        else if (this.cardShouzhenOption.case_info == '') wrongTxt = '病例主诉不能为空'
        else if (this.addCardImgOption.cemian_pic == '') wrongTxt = '请上传侧面照'
        else if (this.addCardImgOption.zhengmian_pic == '') wrongTxt = '请上传正面照'
        else if (this.addCardImgOption.zhengmian_weixiao_pic == '') wrongTxt = '请上传正面微笑照'
        else if (this.addCardImgOption.youce_yaohe_pic == '') wrongTxt = '请上传右侧位咬合照'
        else if (this.addCardImgOption.zhengwei_yaohe_pic == '') wrongTxt = '请上传正位咬合照'
        else if (this.addCardImgOption.zuoce_yaohe_pic == '') wrongTxt = '请上传左侧咬合照'
        else if (this.addCardImgOption.quanjing_pic == '') wrongTxt = '请上传全景照'
        else if (this.addCardImgOption.ceweimian_x_pic == '') wrongTxt = '请上传侧位片（x光）'
        else if (this.addCardImgOption.shanglingyalie_pic == '') wrongTxt = '请上传上颌牙列照'
        else if (this.addCardImgOption.xialingyalie_pic == '') wrongTxt = '请上传下颌牙列照'
        obj = {
          ...this.cardShouzhenOption,
          ...this.addCardImgOption,
          id: this.$route.query.card_id,
        }
      } else if (this.createType == '复诊卡') {
        this.cardFuzhenOption.card_date = new Date(this.cardFuzhenOption.card_date).toLocaleDateString().replaceAll('/', '.')
        if (this.cardFuzhenOption.card_date == '') wrongTxt = '复诊日期不能为空'
        else if (this.cardFuzhenOption.being_treatment.trim() == '') wrongTxt = '复诊情况不能为空'
        obj = {
          ...this.cardFuzhenOption,
          ...this.addCardImgOption,
          id: this.$route.query.card_id,
        }
      } else if (this.createType == '会诊卡') {
        this.cardHuizhenOption.card_date = new Date(this.cardHuizhenOption.card_date).toLocaleDateString().replaceAll('/', '.')
        if (this.cardHuizhenOption.card_date == '') wrongTxt = '会诊卡时间不能为空'
        else if (this.cardHuizhenOption.being_treatment.trim() == '') wrongTxt = '会诊卡情况不能为空'
        obj = {
          ...this.cardHuizhenOption,
          ...this.addCardImgOption,
          id: this.$route.query.card_id,
        }
      } else if (this.createType == '图像卡') {
        let textIndex = this.cardTuxiangOption.image_card_list.find((item, index) => {
          return item.text.trim() == ''
        })
        let imgIndex = this.cardTuxiangOption.image_card_list.find((item, index) => {
          return item.img.length == 0
        })
        if (this.cardTuxiangOption.being_treatment == '') wrongTxt = '正在进行的诊疗情况不能为空'
        else if (imgIndex) wrongTxt = '请上传图片并填写图片描述'
        else if (textIndex) wrongTxt = '请上传图片并填写图片描述'
        obj = {
          ...this.cardTuxiangOption,
          id: this.$route.query.card_id,
        }
      }
      if (wrongTxt != '') {
        this.$refs.contRef.scrollTo({
          top: this.menuOffsetTop[0],
          behavior: 'smooth'
        })
        this.$message({
          type: 'error',
          message: wrongTxt
        })
        return false
      }
      this.$store.commit('workStart')
      UpdateCaseCard(obj).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.$router.push({
            name: '病历管理',
            query: {
              id: this.createItem.id,
              card_id: res.data.id
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: res.message[0]
          })
        }
        this.$store.commit('workOver')
      })
    }
  }
}
</script>
<style scoped src="../../assets/css/consumables.css"></style>
<style scoped src="../../assets/css/doctor-detail.css"></style>
<style scoped src="../../assets/css/case_management_add_case.css"></style>
<style>
.add-data-item-input {
  position: relative;
}

.add-data-item-input input, .add-data-item .el-cascader input {
  width: 176px;
  height: 34px;
  background: #F4F4F4;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 14px;
  border: none;
  padding-left: 10px !important;
}

.add-data-item .el-cascader .el-input .el-icon-arrow-down {
  line-height: 36px;
}

.add-data-item-input .el-input__prefix {
  left: 150px;
  top: -2px;
}

.add-data-item-input .el-icon-arrow-right {
  color: #B1B1B1;
  font-size: 12px;
  font-weight: bold;
}

.add-data-item-input .icon-youjiantou {
  position: absolute;
  right: 10px;
  color: #B1B1B1;
  font-size: 10px;
  top: 8px;
  font-weight: bold;
}

.add-data-item-input input::placeholder {
  color: rgba(60, 60, 67, 0.3);
}

.add-data-item-input input:focus {
  background: rgba(254, 212, 0, 0.05);
  border: 1px solid #FED400;
}
/*上传图片样式*/
.upload-img-item .el-upload-dragger{
  width: fit-content;
  height: 100%;
  border: none;
  display: flex;
}
</style>

